import createRoute from '@widesk-ui/tools/createRoute';

const route = createRoute.customFromService(
	`Flux d'activités`,
	'/configuration/events',
	'audit',
	'EventTimeline',
);

export default route;